"use client";
import { useId } from "react";
import PropTypes from "prop-types";
import Link from "next/link";

import { createImageUrl } from "helpers/create-image-url";

import LocationIcon from "assets/svg/location_icon.svg";

import Price from "components/common/price";
import AddFavoriteButton from "components/common/add-favorite-button";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import styles from "./styles.module.css";

const VerticalCard = ({ id, media, title, list, location, locationSummary, price, url }) => {
  const keyId = useId();
  const mediaUrl = createImageUrl(media, {
    width: 218,
    height: 122,
  });

  const cityName = location?.cityName;
  const districtName = location?.districtName;
  const townName = location?.townName;

  const isConstructionDeal = price?.alternativeValue === "Kat Karşılığı";

  return (
    <Link href={url} className={styles.wrapper}>
      <div className={styles.mediaWrap}>
        <LazyImage src={mediaUrl} alt="Emlakjet" />
      </div>
      <div className={styles.contentWrap}>
        <div className={styles.favoriteIcon}>
          <AddFavoriteButton cityName={cityName} districtName={districtName} townName={townName} listingId={id} />
        </div>
        <h3 className={styles.title} title={title}>
          {title}
        </h3>
        {list && (
          <ul className={styles.list}>
            {list.map((item, index) => (
              <li key={`${keyId}-${index}`}>{item.value}</li>
            ))}
          </ul>
        )}
        <div className={styles.location} title={locationSummary}>
          <span className={styles.locationIconWrap}>
            <LocationIcon />
          </span>
          {locationSummary}
        </div>
        {price && (
          <span className={styles.priceWrap} title={`${price.value} ${price.currency}`}>
            {isConstructionDeal ? price.alternativeValue : <Price price={price.value} currency={price.currency} />}
          </span>
        )}
      </div>
    </Link>
  );
};

VerticalCard.propTypes = {
  media: PropTypes.string,
  title: PropTypes.string,
  list: PropTypes.array,
  locationSummary: PropTypes.string,
  location: PropTypes.object,
  price: PropTypes.object,
  url: PropTypes.string,
  id: PropTypes.number,
};

export default VerticalCard;
